/// <amd-module name="typeahead/features/HotelSuggestionUrlModifier" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../typings/typeahead/IPageLoadHandler.d.ts" />

import {SubmitClickedMessage} from "typeahead/core/message/SubmitClickedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

const configuration: IStripingConfiguration[] = [
    {
        clients: ["Homepage", "HotelsLandingPage", "AWSHomepage"],
        tabs: ["hotel"],
    },
];

export class HotelSuggestionUrlModifier implements IPageLoadHandler {

    public handlePageLoad(options: any, context: IContext): JQueryPromise<undefined> {

        let deferred: JQueryDeferred<undefined> = $.Deferred();

        TypeaheadMessage.subscribe(
            SubmitClickedMessage.getTopic(),
            (topic: string, message: SubmitClickedMessage) => {
                context.tab = this.getMercuryWzdTab();

                ExecutionHelper.shouldExecute(context, configuration)
                    .done((result: boolean): void => {

                        if (result) {
                            // Grab the tab input field for the relevant tab
                            let tabInputField: JQuery = $("[data-gcw-storeable-name=gcw-destination]:visible");

                            let selectedHotelIdElemId: string = "#" + $(tabInputField).attr("data-hotel_id_element");
                            let relevantCityNameElemId: string = "#" + $(tabInputField).attr("data-city_element");

                            let selectedHotelIdElem: JQuery = $(selectedHotelIdElemId);
                            let selectedHotelId: string = $(selectedHotelIdElem).val();
                            let relevantCityNameElem: JQuery = $(relevantCityNameElemId);
                            let relevantCityName: string = $(relevantCityNameElem).val();

                            if (selectedHotelId && relevantCityName) {
                                // Add the name attribute to the city input and
                                // remove the name attribute from destination input
                                $(relevantCityNameElem).attr("name", "destination");
                                $(tabInputField).removeAttr("name");
                            } else {
                                // Add the name attribute to the destination input and
                                // remove the name attribute from city input
                                $(tabInputField).attr("name", "destination");
                                $(relevantCityNameElem).removeAttr("name");
                            }
                        }
                    })
                    .always((): void => {
                        deferred.resolve();
                    });
            });

        return deferred.promise();
    }

    private getMercuryWzdTab() {
        return $("li.tab:visible").children("button.on").data("lob");
    }

}
